import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { media } from '../themes/theme';
import { FocusStylesInverted } from '../../styles/FocusStyles';
import { AssistiveTechnologyOnly } from '../../styles/AssistiveTechnologyOnly';
const NavWrapper = styled.nav `
  display: flex;
  justify-content: center;
  max-width: 18rem;

  > *:last-child {
    margin-right: 0;
    padding-right: 0;
  }
`;
const SocialLink = styled.a `
  box-sizing: content-box;
  color: ${props => props.theme.White};
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  padding: 0.5rem;
  margin: -0.5rem;
  margin-right: 1rem;

  ${media.laptop `
    width: 1.4375rem;
    height: 1.4375rem;
    margin-right: 0.5rem;
  `};

  ${FocusStylesInverted};

  svg {
    width: 100%;
    height: 100%;
  }
`;
const VisuallyHiddenLabel = styled.h2 `
  ${AssistiveTechnologyOnly}
`;
const ID_SOCIAL_NAVIGATION_FOOTER_LABEL = 'social-navigation-footer-label';
export const SocialNavigation = ({ socialMediaLinks, }) => {
    const { t } = useTranslation('Footer');
    return (React.createElement(NavWrapper, { "aria-labelledby": ID_SOCIAL_NAVIGATION_FOOTER_LABEL },
        React.createElement(VisuallyHiddenLabel, { id: ID_SOCIAL_NAVIGATION_FOOTER_LABEL }, t('SocialNavigationLabel')),
        socialMediaLinks.map(({ component: Component, to, title, dataTrackingId: dataTrackingIdDeprecated, 'data-trackingid': dataTrackingId, onClick, }) => (React.createElement(SocialLink, { key: to, href: to, "aria-label": title, "data-tracking": dataTrackingId || dataTrackingIdDeprecated, onClick: onClick },
            React.createElement(Component, null))))));
};
